import type { Feature } from '@luna/gatekeeper';

export const accountLinkage: Feature = {
    enabled: false,
    _description: 'Displays account linkage card on the bank card settings page',
};
